import { render, staticRenderFns } from "./SharedProformaFields.vue?vue&type=template&id=03400b79"
import script from "./SharedProformaFields.vue?vue&type=script&lang=js"
export * from "./SharedProformaFields.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports